import React  from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { useDispatch } from "react-redux";
import { closeFirmwareDialog } from '../state/files/actions';

const FirmwareModal = ({
    open,
   // setOpenFirmware,
    value,
    setFirmwareData,
    firmwareFile,
    setFirmwareFile,
    handleFormData,
    controllersList
}) => {
    const dispatch = useDispatch();
    // Function to set values of the Form Fields
    const changeHandler = (e) => {
        setFirmwareData((prevState) =>
        ({...prevState, [e.target.name]: e.target.value }));
    };

    // Function to set the file value
    const changeFileHandler = (event) => {
        setFirmwareFile(event.target.files[0]);
    };

     // Function to handle the close of Form popup
    const handleClose = (event, reason) => {
        setFirmwareFile('');
        setFirmwareData({
            version : '',
            releaseNotes:'',
            controllerId: controllersList[0]?.id,
        });
        //setOpenFirmware(false);
        dispatch(closeFirmwareDialog());
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open}>
            <DialogTitle>Upload Firmware</DialogTitle>
            <DialogContent dividers> 
  
                <TextField  
                    margin="dense"
                    id="version"
                    label="Upload Version"
                    name="version"
                    fullWidth
                    //sx={{paddingBottom:2}}
                    value={value.version}
                    onChange={changeHandler}
                    error={value.version === ""}
                    helperText={value.version === "" ? "Required Field!" : " "}
                />
                <FormControl fullWidth 
                 sx={{  paddingBottom: 2 }}
                >
                    <InputLabel id="demo-simple-select-standard-label">Controller</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        label="Products"
                        sx={{ "&:focus": {
                            backgroundColor: "#ffffff"
                          } 
                        }}
                        value={value.controllerId}
                        onChange={changeHandler}
                        name="controllerId"
                        error={value.controllerId === ""}
                    >
                        {controllersList?.map((row, i) => (
                            <MenuItem value={row.id}>{row.controller_name}</MenuItem>
                        ))}
                        
                        {/* <MenuItem value={2}>DC2.4 </MenuItem>
                        <MenuItem value={3}>RDC2-DC2</MenuItem>
                        <MenuItem value={4}>RDC-DC </MenuItem>
                        <MenuItem value={5}>VSC </MenuItem>
                        <MenuItem value={6}>VSC.4 </MenuItem> */}
                    </Select>
                </FormControl>
                <TextField 
                    label="Release Notes" 
                    id="releaseNotes" 
                    name="releaseNotes"
                    multiline
                    rows={4}
                    fullWidth
                    sx={{paddingBottom:2}}
                    value={value.releaseNotes}
                    onChange={changeHandler}
                    error={value.releaseNotes === ""}
                    helperText={value.releaseNotes === "" ? "Required Field!" : " "}
              />
                <InputLabel id="file-select-label">Upload File</InputLabel>
                <Input 
                type="file" 
                name="uploadFile"
                accept=".bin"
                fullWidth
                onChange={changeFileHandler} 
                error={firmwareFile === "" }              
                >Upload File</Input>
                { firmwareFile === "" ? <FormHelperText sx={{color:'#d32f2f'}} id="component-error-text">Required Field!</FormHelperText> : <></> }
            </DialogContent>
            <DialogActions>
                <Button  variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleFormData}
                >Submit</Button>
                <Button  variant="contained"
            size="medium"
            color="error" onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default FirmwareModal
